import React, { Component } from 'react';
import {
  Navbar, Nav, NavItem,
  Grid, Row, Col,
  Image
} from 'react-bootstrap';
import { Router, Route, IndexRoute, Link, hashHistory } from 'react-router'
import FontAwesome from "react-fontawesome";

import "./App.css";
import "./font-awesome.css";
import Logo from "./logo.png";
import GCP from "./GCP.png";

import Start from "./Start";

class NavBar extends Component {
  render() {
    const contact = atob("aW5mb0Bqb29uaXguc2U=");
    return (
      <div>
        <Navbar className="joonix" inverse>
          <Navbar.Header>
            <Link to="/" className="navbar-left">
              <img className="logo" src={Logo} role="presentation" />
            </Link>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight>
              <NavItem href={"mailto:" + contact}>Kontakta</NavItem>
              <NavItem href="http://blog.joonix.se">Blogg</NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Grid>
          {this.props.children}
        </Grid>
        <footer className="app">
          <Grid>
            <Row>
                <Col smOffset={1} sm={3}>
                <h4>Följ</h4>
                <ul>
                  <li>
                    <a href="http://blog.joonix.se"><FontAwesome name="book" size="2x" /><span>Blogg</span></a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/in/joonixse"><FontAwesome name="linkedin" size="2x" /><span>LinkedIn</span></a>
                  </li>
                  <li>
                    <a href="https://github.com/joonix"><FontAwesome name="github" size="2x" /><span>Github</span></a>
                  </li>
                </ul>
              </Col>
              <Col sm={4}>
                <h4>Kontakta</h4>
                <ul>
                  <li><FontAwesome name="at" size="2x" /><a href={"mailto:" + contact}>{contact}</a></li>
                  <li><FontAwesome name="phone" size="2x" />+46 31 799 5432</li>
                  <li><FontAwesome name="skype" size="2x" /><a href="skype:balboah?call">Skype call</a></li>
                </ul>
              </Col>
              <Col sm={3}>
                <Image responsive src={GCP} />
              </Col>
            </Row>
          </Grid>
        </footer>
      </div>
    );
  }
}

class App extends Component {
  render() {
    return (
      <Router history={hashHistory}>
        <Route path="/" component={NavBar}>
          <IndexRoute component={Start} />
        </Route>
      </Router>
    );
  }
}

export default App;


/** WEBPACK FOOTER **
 ** ./src/App.js
 **/